import { useRef, useState } from 'react';

import { Alert, Button, Center, Field, Flex, Heading, Highlight, Icon, Image, Input, InputGroup, List, Textarea } from "@chakra-ui/react";

import { Toaster, toaster } from "src/components/ui/toaster"
import emailjs from '@emailjs/browser';

import './styles/ContactUsComponent.css';
import { FaCircleArrowRight, FaEllipsis, FaPaperPlane } from "react-icons/fa6";

function ContactUsComponent(props: any) {

    const form = useRef(null);
    const [formName, setFormName] = useState('');
    const [formEmail, setFormEmail] = useState('');

    const sendEmail = (e: any) => {

        console.log(form);

        let emptyFormName = false;
        let emptyFormEmail = false;

        if (formName!.length === 0) {
            emptyFormName = true;
            toaster.create({
                title: `Please fill out your name`,
                type: 'error',
                duration: 2000
            });
        }
        if (formEmail!.length === 0) {
            emptyFormEmail = true;
            toaster.create({
                title: `Please fill out your email`,
                type: 'error',
                duration: 2000
            });
        }

        if (emptyFormName || emptyFormEmail) {
            return;
        }

        e.preventDefault();
        emailjs.sendForm('service_4uejlon', 'template_1yo3xqv', form.current, {
            publicKey: 'fSTInRqlBJbgPFURz',
        })
        .then(
            () => {
                toaster.create({
                    title: `Email sent successfully! Expect a response within 1 business day.`,
                    type: 'success',
                    duration: 3000
                });
            },
            (error) => {
                toaster.create({
                    title: `Unable to send email. Try again later or email 'negotiateofferme@gmail.com' directly.`,
                    type: 'error',
                    duration: 5000
                });
            },
        );
    };

    return (
        // Need to use this trick so we jump to the offset of navigation bar
        <div style={{
            paddingTop: '69px',
            marginTop: '-69px',
        }}
        id='contactus'>
            {/* Desktop only view */}
            <Flex className="contact_us_component__parent" direction='column' gap='8' justify='center' >
                <Flex justify='center' gap='12'>
                    <Flex direction='column' gap='8' maxW='550px'>
                        <Flex direction='column'>
                            <Heading color='black' fontWeight='bold' size='4xl'>
                                We know your time is valuable.
                            </Heading>
                            <Heading color='black' fontWeight='bold' size='4xl'>
                                <Highlight query='1 Business Day.' styles={{color: '#FB5383'}}>
                                    Response within 1 Business Day.
                                </Highlight>
                            </Heading>
                        </Flex>
                        <Flex direction='column' gap='4'>
                            <Flex gap='4'>
                                <Icon size='md' style={{marginTop: "5px"}}>
                                    <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    The negotiations process is always changing. Engaging an expert as early on as possible gives you the best possible outcome.
                                </Heading>
                            </Flex>
                            <Flex gap='4'>
                            <Icon size='md' style={{marginTop: "5px"}}>
                            <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    Saying the wrong thing as early as the initial recruiter phone screen can cost you during the offer negotiations phase
                                </Heading>
                            </Flex>
                            <Flex gap='4'>
                                <Icon size='md' style={{marginTop: "5px"}}>
                                    <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    Get your maximum offer possible!
                                </Heading>
                            </Flex>
                        </Flex>
                    </Flex>
                    <form ref={form} onSubmit={sendEmail}>
                        <Flex direction='column' gap='6' width='450px'>
                            <Field.Root required>
                                <Field.Label color='black'>
                                    Name <Field.RequiredIndicator />
                                </Field.Label>
                                <Input border='1px solid black' color='black'  placeholder="Enter your name" size='lg' name="name" required id='form_name' onChange={(e) => {setFormName(e.currentTarget.value)}}/>
                                <Field.HelperText color='black'>What's your name?</Field.HelperText>
                            </Field.Root>
                            <Field.Root required>
                                <Field.Label color='black'>
                                    Email <Field.RequiredIndicator />
                                </Field.Label>
                                <Input border='1px solid black' color='black'  placeholder="Enter your email" size='lg' name="email" required id='form_email' onChange={(e) => {setFormEmail(e.currentTarget.value)}}/>
                                <Field.HelperText color='black'>We'll never share your email.</Field.HelperText>
                            </Field.Root>
                            <Textarea border='1px solid black' color='black' height='150px' maxLength={400} variant="outline" placeholder="Anything else we should know? (Timeline, etc.)" resize='none' size='lg' name="message"/>
                            <Button
                                backgroundColor='#FB5383'
                                color='white'
                                className='button'
                                rounded='md'
                                onMouseDown={sendEmail}
                                size='lg'
                            >
                                Submit
                                <FaPaperPlane style={{
                                    height: "15px",
                                    marginLeft: "-5px"
                                }}/>
                            </Button>
                        </Flex>
                    </form>
                </Flex>
            </Flex>

            {/* Mobile only view */}
            <Flex className="contact_us_component__mobile_parent" direction='column' gap='8' justify='center' >
                <Flex direction='column' justify='center' gap='6'>
                    <Flex direction='column' gap='8'>
                        <Flex direction='column'>
                            <Heading color='black' fontWeight='bold' size='4xl'>
                                We know your time is valuable.
                            </Heading>
                            <Heading color='black' fontWeight='bold' size='4xl'>
                                <Highlight query='1 Business Day.' styles={{color: '#FB5383'}}>
                                    Response within 1 Business Day.
                                </Highlight>
                            </Heading>
                        </Flex>
                        <Flex direction='column' gap='4'>
                            <Flex gap='4'>
                                <Icon size='md' style={{marginTop: "5px"}}>
                                    <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    The negotiations process is always changing. Engaging an expert as early on as possible gives you the best possible outcome.
                                </Heading>
                            </Flex>
                            <Flex gap='4'>
                            <Icon size='md' style={{marginTop: "5px"}}>
                            <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    Saying the wrong thing as early as the initial recruiter phone screen can cost you during the offer negotiations phase
                                </Heading>
                            </Flex>
                            <Flex gap='4'>
                                <Icon size='md' style={{marginTop: "5px"}}>
                                    <FaCircleArrowRight color='#FB5383' size='55px'/>
                                </Icon>
                                <Heading color='black' size='lg' textAlign='left'>
                                    Get your maximum offer possible!
                                </Heading>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Center>
                        <Icon color='#FB5383'>
                            <FaEllipsis/>
                        </Icon>
                    </Center>
                    <form ref={form} onSubmit={sendEmail}>
                        <Flex direction='column' gap='6'>
                            <Field.Root required>
                                <Field.Label color='black'>
                                    Name <Field.RequiredIndicator />
                                </Field.Label>
                                <Input border='1px solid black' color='black'  placeholder="Enter your name" size='lg' name="name" required id='form_name' onChange={(e) => {setFormName(e.currentTarget.value)}}/>
                                <Field.HelperText color='black'>What's your name?</Field.HelperText>
                            </Field.Root>
                            <Field.Root required>
                                <Field.Label color='black'>
                                    Email <Field.RequiredIndicator />
                                </Field.Label>
                                <Input border='1px solid black' color='black'  placeholder="Enter your email" size='lg' name="email" required id='form_email' onChange={(e) => {setFormEmail(e.currentTarget.value)}}/>
                                <Field.HelperText color='black'>We'll never share your email.</Field.HelperText>
                            </Field.Root>
                            <Textarea border='1px solid black' color='black' height='150px' maxLength={400} variant="outline" placeholder="Anything else we should know? (Timeline, etc.)" resize='none' size='lg' name="message"/>
                            <Button
                                backgroundColor='#FB5383'
                                color='white'
                                className='button'
                                rounded='md'
                                onMouseDown={sendEmail}
                                size='lg'
                            >
                                Submit
                                <FaPaperPlane style={{
                                    height: "15px",
                                    marginLeft: "-5px"
                                }}/>
                            </Button>
                        </Flex>
                    </form>
                </Flex>
            </Flex>
        </div>
    );
}

export default ContactUsComponent;
